import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "border-width"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#border-width" }),
  /*#__PURE__*/_createTextVNode(" Border Width ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use the standard "),
  /*#__PURE__*/_createVNode("code", null, ".border-{width}"),
  /*#__PURE__*/_createTextVNode(" class with "),
  /*#__PURE__*/_createVNode("code", null, ".pulse-ring"),
  /*#__PURE__*/_createTextVNode(" to set a pulse ring's border width. ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Where ")
const _hoisted_6 = /*#__PURE__*/_createVNode("code", null, "width", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" is one of: ")
const _hoisted_8 = { class: "pt-3" }
const _hoisted_9 = { class: "py-5" }
const _hoisted_10 = { class: "rounded border p-10 pb-0 d-flex flex-wrap align-items-center" }
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createVNode("ul", _hoisted_8, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.widths, (item, i) => {
          return (_openBlock(), _createBlock("li", {
            key: i,
            class: "py-2"
          }, [
            _createVNode("code", null, _toDisplayString(item), 1),
            _createTextVNode(" - for classes that set border width to " + _toDisplayString(item) + "px ", 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.widths, (item, i) => {
          return (_openBlock(), _createBlock("a", {
            key: i,
            href: "#",
            class: "btn btn-icon btn-light pulse pulse-primary me-10 mb-10"
          }, [
            _createVNode("span", _hoisted_11, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks.svg" })
            ]),
            _createVNode("span", {
              class: [`border-${item}`, "pulse-ring"]
            }, null, 2)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_CodeHighlighter, {
        fieldHeight: 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<a href="#" class="btn btn-icon btn-light pulse pulse-primary">
          <span class="svg-icon svg-icon-2"><svg>...</svg></span>
          <span class="pulse-ring border-0"></span>
        </a>
        <a href="#" class="btn btn-icon btn-light pulse pulse-primary">
          <span class="svg-icon svg-icon-2"><svg>...</svg></span>
          <span class="pulse-ring border-1"></span>
        </a>
        <a href="#" class="btn btn-icon btn-light pulse pulse-primary">
          <span class="svg-icon svg-icon-2"><svg>...</svg></span>
          <span class="pulse-ring border-2"></span>
        </a>
        <a href="#" class="btn btn-icon btn-light pulse pulse-primary">
          <span class="svg-icon svg-icon-2"><svg>...</svg></span>
          <span class="pulse-ring border-3"></span>
        </a>
        <a href="#" class="btn btn-icon btn-light pulse pulse-primary">
          <span class="svg-icon svg-icon-2"><svg>...</svg></span>
          <span class="pulse-ring border-4"></span>
        </a>
        <a href="#" class="btn btn-icon btn-light pulse pulse-primary">
          <span class="svg-icon svg-icon-2"><svg>...</svg></span>
          <span class="pulse-ring border-5"></span> </a
        >`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}